// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cls-1[data-v-119a83cb] {\n  fill: none;\n  stroke: currentColor;\n  stroke-miterlimit: 10;\n  stroke-width: 0.4px;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n.cls-2[data-v-119a83cb] {\n  fill: currentColor;\n  stroke: currentColor;\n  stroke-width: 0.1;\n  stroke-linecap: round;\n}\n", ""]);
// Exports
module.exports = exports;
